import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { RankingUsina } from "../../types";
import { numberPtBr } from "../../../../main/utils/utils";

export default function RankingUsinasChart(props: {
    rankingUsinas: RankingUsina[],
}) {
    const { rankingUsinas } = props

    const hasData = Object.keys(rankingUsinas).length > 0

    const energiaGeradaDecrescente = rankingUsinas.sort((a, b) => (a.energiaGerada || 0) - (b.energiaGerada || 0));

    const options: EChartsOption = {
        title: {
            text: "Geração por usina",
            textStyle: {
                fontSize: 12,
            },
        },
        tooltip: {
            trigger: "item",
            formatter: function (params: any) {
                if (Array.isArray(params)) params = params[0];

                const usinaName = energiaGeradaDecrescente[params.dataIndex]?.usinaCode;

                const valorFormatado = typeof params.value === "number"
                    ? params.value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    : params.value;

                return `<strong>${usinaName} - ${params.name}</strong><br/>${params.seriesName}: ${valorFormatado} MWh`;
            }
        },
        grid: {
            left: 30,
            right: 20,
            bottom: 30,
            top: 60,
            containLabel: true,
        },
        backgroundColor: "transparent",
        xAxis: [
            {
                type: 'category',
                data: energiaGeradaDecrescente.map((usina) => usina.usinaCode),
                axisTick: {
                    alignWithLabel: true
                },
                axisLabel: {
                    fontSize: 10,
                    rotate: 65,
                    interval: 0
                },
            }
        ],
        yAxis: [
            {
                name: "MWh",
                type: 'value',
            }
        ],
        series: [
            {
                name: "Energia Gerada (MWh)",
                type: "bar",
                itemStyle: {
                    color: "#ee7d00",
                },
                label: {
                    show: true,
                    formatter: (params: any) => {
                        return params.value > 0 ? `${numberPtBr(params.value ?? 0,
                            1
                        )} MWh` : "";
                    },
                    color: '#fff',
                    rotate: 90
                },
                data: energiaGeradaDecrescente.map((usina) => usina.energiaGerada ?? 0)
            }
        ]
    }

    return (
        <>
            {hasData ? (
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "90%",
                        width: "100%",
                    }}
                >
                    <RopChart option={options} />
                </Container>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <EmptyTable title="Nenhum dado encontrado!" />
                </Box>
            )}
        </>
    );
}
